import { css, type Theme } from "@emotion/react";

export const fullBleedContainer = css`
  margin: 0;
  max-width: none;
  padding: 0;
  width: 100%;
`;

export const fullBleedFooter = css`
  margin-top: 0;
`;

export const mobileCountrySelectRow = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  padding: ${theme.ds5.spacing.gap.medium} ${theme.ds5.spacing.gap.large} 0;
`;

export const mobileHeader = css`
  display: flex;
  justify-content: center;
`;
